import {field} from "./misc/StoreField";
import {MakeStore, StoreObject} from "../../stem-core/src/state/Store";


class UserSession extends StoreObject {
    @field("UserProfile") user;
    @field(String) key;
    @field(Date) createdAt;
    @field(Date) expiresAt;
    @field(Date) revokedAt;
    @field(String) ip;
    @field(String) countryCode;
    @field("Jurisdiction") jurisdiction;
}

export const UserSessionStore = MakeStore("UserSession", UserSession);
